import { normalizeSiteHref, rewriteAssetPath } from "./siteRoutes.js"

const ATTRIBUTES = /\b(href|src|poster)=("([^"]*)"|'([^']*)')/g
const SIMPLE_SELECT = /<label>\s*<span>([^<]+)<\/span>\s*<select name="([^"]+)">([\s\S]*?)<\/select>\s*<\/label>/g
const SELECT_OPTION = /<option value="([^"]*)">([^<]*)<\/option>/g

export function prepareSiteHtml(html, pagePath) {
  return replaceNativeSelects(html).replace(ATTRIBUTES, (match, attribute, quoted, doubleValue, singleValue) => {
    const value = doubleValue ?? singleValue ?? ""
    const nextValue = attribute === "href"
      ? normalizeSiteHref(value, pagePath)
      : rewriteAssetPath(value)

    const quote = quoted.startsWith("'") ? "'" : "\""
    return `${attribute}=${quote}${escapeAttribute(nextValue)}${quote}`
  })
}

function replaceNativeSelects(html) {
  let customSelectIndex = 0

  return html.replace(SIMPLE_SELECT, (match, label, name, optionHtml) => {
    const options = Array.from(optionHtml.matchAll(SELECT_OPTION), ([, value, text]) => ({ value, text }))
    if (!options.length) return match

    customSelectIndex += 1
    const listboxId = `custom-select-${name}-${customSelectIndex}`
    const labelId = `${listboxId}-label`
    const valueId = `${listboxId}-value`
    const selected = options[0]

    return `<div class="custom-select-field">
                  <span id="${escapeAttribute(labelId)}">${escapeHtml(label)}</span>
                  <input type="hidden" name="${escapeAttribute(name)}" value="${escapeAttribute(selected.value)}" data-custom-select-input>
                  <div class="custom-select" data-custom-select>
                    <button class="custom-select-trigger" type="button" data-custom-select-trigger aria-haspopup="listbox" aria-expanded="false" aria-controls="${escapeAttribute(listboxId)}" aria-labelledby="${escapeAttribute(labelId)} ${escapeAttribute(valueId)}">
                      <span id="${escapeAttribute(valueId)}" data-custom-select-label>${escapeHtml(selected.text)}</span>
                      <i aria-hidden="true"></i>
                    </button>
                    <div class="custom-select-menu" id="${escapeAttribute(listboxId)}" role="listbox" aria-labelledby="${escapeAttribute(labelId)}" data-custom-select-menu>
                      ${options.map((option, index) => customSelectOption(option, index === 0)).join("\n                      ")}
                    </div>
                  </div>
                </div>`
  })
}

function customSelectOption(option, selected) {
  return `<div class="custom-select-option${selected ? " is-selected" : ""}" role="option" aria-selected="${selected}" data-value="${escapeAttribute(option.value)}" tabindex="-1">${escapeHtml(option.text)}</div>`
}

function escapeAttribute(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
}
